import { useEffect, useRef } from "react";

/**
 * Hook pour détecter les clics à l'extérieur d'un élément
 * @param callback - Fonction appelée lors d'un clic à l'extérieur
 * @returns ref - Référence à attacher à l'élément
 */
export function useClickOutside<T extends HTMLElement>(callback: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    // Ajouter l'écouteur d'événement
    document.addEventListener("mousedown", handleClickOutside);

    // Nettoyer l'écouteur d'événement
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
}
